import { render, staticRenderFns } from "./customDtl.vue?vue&type=template&id=4a547433&scoped=true&"
import script from "./customDtl.vue?vue&type=script&lang=js&"
export * from "./customDtl.vue?vue&type=script&lang=js&"
import style0 from "./customDtl.vue?vue&type=style&index=0&id=4a547433&prod&lang=scss&scoped=true&"
import style1 from "./customDtl.vue?vue&type=style&index=1&id=4a547433&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a547433",
  null
  
)

export default component.exports